import { render, staticRenderFns } from "./updatePTKN.vue?vue&type=template&id=d65b4eaa&lang=pug&"
import script from "./updatePTKN.vue?vue&type=script&lang=js&"
export * from "./updatePTKN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports